import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import { ClientAddEdit } from "../component/features/clients/ClientAddEdit";
import { ClientList } from "../component/features/clients/ClientList";

export class ClientRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path={"/users"} component={ClientList} />
                <Route exact path={[`/users/add`, `/users/edit/:id`]} component={ClientAddEdit} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};
